import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'characterCount',
    'characterCountContainer',
    'characterCountTooltip',
    'content',
    'emojiPickerTrigger',
    'file',
    'mediaPreviewContainer',
    'mediaId',
  ];

  connect() {
    this.fileURLs = [];
  }

  disconnect() {
    this.fileURLs.forEach((fileURL) => {
      URL.revokeObjectURL(fileURL);
    });
  }

  characterCountTargetConnected() {
    this.updateCharacterCount();
  }

  contentTargetConnected(target) {
    target.addEventListener('input', () => {
      this.updateCharacterCount();
    });
  }

  emojiPickerTriggerTargetConnected(target) {
    const options = {
      onEmojiSelect: (e) => {
        const textarea = this.contentTarget;
        const cursorPosition = textarea.selectionEnd;
        const start = textarea.value.substring(0, textarea.selectionStart);
        const end = textarea.value.substring(textarea.selectionStart);
        const text = start + e.native + end;

        textarea.value = text;
        textarea.focus();
        textarea.selectionEnd = cursorPosition + e.native.length;

        this.updateCharacterCount();
        this.hideElement(this.emojiPicker);
      },
      onClickOutside: ({ srcElement }) => {
        if (this.emojiPickerTriggerTarget === srcElement) {
          return;
        }

        this.hideElement(this.emojiPicker);
      },
    };

    this.emojiPicker = new window.EmojiMart.Picker(options);
    this.emojiPicker.classList.add('absolute', 'top-8', 'z-10');

    this.hideElement(this.emojiPicker);

    target.addEventListener('click', (e) => {
      if (this.emojiPickerTriggerTarget === e.target) {
        this.toggleElement(this.emojiPicker);
      }
    });

    target.appendChild(this.emojiPicker);
  }

  pickMedia({ currentTarget, params }) {
    const element = currentTarget.firstElementChild.cloneNode(true);

    this.mediaIdTarget.value = params.id;
    this.renderPreview(element);
  }

  pickFile({ target }) {
    const file = target.files[0];
    const url = URL.createObjectURL(file);

    this.fileURLs.push(url);

    let element;

    if (file.type.startsWith('image')) {
      element = document.createElement('img');
    } else {
      element = document.createElement('video');
      element.controls = true;
    }

    element.src = url;
    element.className = 'object-cover';

    this.renderPreview(element);
  }

  removeMedia() {
    this.mediaIdTarget.value = null;
    this.fileTarget.value = '';

    this.mediaPreviewContainerTarget.innerHTML = '';
  }

  renderPreview(element) {
    element.classList.add('w-full');

    this.mediaPreviewContainerTarget.replaceChildren(element);

    this.showElement(this.mediaPreviewContainerTarget);
  }

  updateCharacterCount() {
    const count = this.contentTarget.value.length;
    const isError = count > 280;
    const isWarning = count >= 230;

    let className;

    this.characterCountTarget.innerText = count;

    if (isError) {
      className = 'text-error-600';
      this.showElement(this.characterCountTooltipTarget);
    } else {
      className = isWarning ? 'text-warning-600' : 'text-neutral-600';

      this.hideElement(this.characterCountTooltipTarget);
    }

    this.characterCountContainerTarget.classList.remove(
      'text-neutral-600',
      'text-warning-600',
      'text-error-600'
    );
    this.characterCountContainerTarget.classList.add(className);
  }

  showElement(element) {
    element.classList.remove('hidden');
  }

  hideElement(element) {
    element.classList.add('hidden');
  }

  toggleElement(element) {
    element.classList.toggle('hidden');
  }

  showFilePicker() {
    this.fileTarget.click();
  }
}
